export default __webpack_public_path__ + "static/media/lambspreschool.175c98dd.png";